<div class="modal fade" role="dialog" [id]="'infoSocietaModal' + randId">
    <div class="modal-dialog" [attr.role]="'document'">
        <div class="modal-content">
            <p class="col-sm-2 col-sm-offset-10 generic-close-modal-btn">
                <button (click)="close()" class="btn btn-default-reverse btn-block btn-sm" [attr.data-dismiss]="'modal'"
                    type="button">Chiudi</button>
            </p>
            <div>
                <div class="titleblock">
                    <h3 class="title1levelNoMargin" style="margin-top: 0;">Altre Info Società</h3>
                </div>
                <div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'text'" [labelInput]="'Fiscale'"
                    [valueInput]="societa?.fiscale"></div>
                <div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'text'" [labelInput]="'Rea Società'"
                    [valueInput]="societa?.reaSocieta"></div>

                <div class="container_tab_nav" *ngIf="societa">
                    <div id="tabs">
                        <ul id="tabsSocieta" class="nav nav-tabs three">
                            <li class="active"><a data-toggle="tab" [href]="'#tabVisureCamerali' + randId">Visure
                                    camerali</a>
                            </li>
                            <li><a data-toggle="tab" [href]="'#tabAnniInteressati' + randId">Anni interessati</a></li>
                            <li><a data-toggle="tab" [href]="'#tabCertificati' + randId">Certificati</a></li>
                        </ul>
                    </div>
                    <div class="tab-content">
                        <div [id]="'tabVisureCamerali' + randId" class="tab-pane fade in active">
                            <table class="table-striped table aggiunta_classificazione table_fondo_oneri">
                                <caption class="sr-only">Tabella visure</caption>
                                <thead>
                                    <th style="width: 50%;">Codice</th>
                                    <th style="width: 50%;">Descrizione</th>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let visura of societa?.visureCamerali">
                                        <td>{{visura.codiceVisura}}</td>
                                        <td>{{visura.descrizioneVisura}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div [id]="'tabAnniInteressati' + randId" class="tab-pane fade in">
                            <table class="table-striped table aggiunta_classificazione table_fondo_oneri">
                                <caption class="sr-only">Tabella anni interessati</caption>
                                <thead>
                                    <th style="width: 25%;">Anno comunicazione</th>
                                    <th style="width: 25%;">Anno annullato</th>
                                    <th style="width: 25%;">Codice causale</th>
                                    <th style="width: 25%;">Descrizione causale</th>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let anno of societa?.anniInteressati">
                                        <td>{{anno.annoComunicazione}}</td>
                                        <td>{{anno.annoAnnullato}}</td>
                                        <td>{{anno.codiceCausale}}</td>
                                        <td>{{anno.descrizioneCausale}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div [id]="'tabCertificati' + randId" class="tab-pane fade in">
                            <table class="table-striped table aggiunta_classificazione table_fondo_oneri">
                                <caption class="sr-only">Tabella certificati</caption>
                                <thead>
                                    <th style="width: 16%;">Codice documento</th>
                                    <!--<th style="width: 11%;">Documenti Richiesti</th>
                                    <th style="width: 11%;">Documenti arrivati con la domanda</th>
                                    <th style="width: 11%;">Documenti incompleti</th>-->
                                    <th style="width: 16%;">Descrizione</th>
                                    <th style="width: 16%;">Data richiesta</th>
                                    <th style="width: 16%;">N. solleciti inviati</th>
                                    <th style="width: 16%;">Numero protocollo entrata</th>
                                    <th style="width: 16%;">Data protocollo entrata</th>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let certificato of societa?.certificati">
                                        <td>{{certificato ? certificato.codiceDocumento : ''}}</td>
                                        <!--<td>{{certificato.documentiRichiesti ? 'SI' : 'No'}}</td>
                                        <td>{{certificato.documentiArrivati ? 'SI' : 'No'}}</td>
                                        <td>{{certificato.documentiIncompleti ? 'SI' : 'No'}}</td>-->
                                        <td>{{certificato ? certificato.descrizioneCertificato : ''}}</td>
                                        <td>{{certificato ? (certificato.dataRichiesta | dateformatter:
                                            'DD/MM/YYYY') :
                                            ''}}</td>
                                        <td>{{certificato ? certificato.numSollecitiInviati: ''}}</td>
                                        <td>{{certificato ? certificato.numProtocolloEntrata: ''}}</td>
                                        <td>{{certificato ? (certificato.dataProtocolloEntrata | dateformatter:
                                            'DD/MM/YYYY') : ''}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>